export default __webpack_public_path__ + "static/media/sports_banner_2.7776824f.png";